import { serializable, alias, primitive } from 'serializr';

export class Nationality {
	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('citizenship', primitive()))
	citizenship?: string;
}
